"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTag = updateTag;
exports.updateMeta = updateMeta;
exports.updateCustomMeta = updateCustomMeta;
exports.updateLink = updateLink;

function updateTag(tagName, keyName, keyValue, attrName, attrValue) {
  var _a;

  var node = document.head.querySelector(tagName + "[" + keyName + "=\"" + keyValue + "\"]");
  if (node && node.getAttribute(attrName) === attrValue) return; // Remove and create a new tag in order to make it work with bookmarks in Safari

  if (node) {
    (_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(node);
  }

  var nextNode = document.createElement(tagName);
  nextNode.setAttribute(keyName, keyValue);
  nextNode.setAttribute(attrName, attrValue);
  document.head.appendChild(nextNode);
}

function updateMeta(name, content) {
  updateTag('meta', 'name', name, 'content', content);
}

function updateCustomMeta(property, content) {
  updateTag('meta', 'property', property, 'content', content);
}

function updateLink(rel, href) {
  updateTag('link', 'rel', rel, 'href', href);
}